import { setupDayjs } from "@eroad/helpers/dayjs";
import { TIMEZONE_USER } from "@eroad/i18n/constants";

import { useAppContext } from "../context/appContext";
import { getLocale } from "../helpers/getLocale";
import { LanguageProvider } from "./languageProvider/LanguageProvider";

type Props = { children: React.ReactNode };

const PhoenixLocaleProvider = ({ children }: Props) => {
  const { userProfile } = useAppContext() || {};

  const timeZone = userProfile?.timeZoneIana || TIMEZONE_USER;
  const locale = getLocale(userProfile?.culture);

  setupDayjs(locale, timeZone);

  return (
    <LanguageProvider locale={locale} timeZone={timeZone}>
      {children}
    </LanguageProvider>
  );
};

export { PhoenixLocaleProvider };
